import { render, staticRenderFns } from "./configBindTipDialog.vue?vue&type=template&id=5d7459ea&scoped=true"
import script from "./configBindTipDialog.vue?vue&type=script&lang=js"
export * from "./configBindTipDialog.vue?vue&type=script&lang=js"
import style0 from "./configBindTipDialog.vue?vue&type=style&index=0&id=5d7459ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7459ea",
  null
  
)

export default component.exports